// AM 1124 Art. 7.II.10 exige la cantidad a dispensar "en números y letras"
// — no existía ningún conversor número→texto en el repo. Alcanza con
// enteros de 0 a 999.999 (cualquier cantidad realista de un medicamento);
// nunca se llama con decimales ni negativos (la cantidad total del wizard
// siempre es un entero positivo).
const UNIDADES = ['cero', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve'];
const DIEZ_A_DIECINUEVE = [
  'diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis', 'diecisiete', 'dieciocho', 'diecinueve',
];
const DECENAS = ['', '', 'veinte', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa'];
const CENTENAS = [
  '', 'ciento', 'doscientos', 'trescientos', 'cuatrocientos', 'quinientos', 'seiscientos', 'setecientos', 'ochocientos', 'novecientos',
];

// "veintiX" corre el acento a la sílaba de la unidad en dós/trés/séis — las
// demás (veinticuatro/cinco/siete/ocho/nueve) no lo necesitan. Bug real
// encontrado 2026-09-03 imprimiendo una fecha en letras (117): salía
// "veintiseis" sin tilde.
const VEINTI_ACENTUADOS: Record<number, string> = { 2: 'veintidós', 3: 'veintitrés', 6: 'veintiséis' };

function menorQueCien(n: number): string {
  if (n < 10) return UNIDADES[n]!;
  if (n < 20) return DIEZ_A_DIECINUEVE[n - 10]!;
  const decena = Math.floor(n / 10);
  const unidad = n % 10;
  if (unidad === 0) return DECENAS[decena]!;
  if (decena === 2) return VEINTI_ACENTUADOS[unidad] ?? `veinti${UNIDADES[unidad]}`;
  return `${DECENAS[decena]} y ${UNIDADES[unidad]}`;
}

function menorQueMil(n: number): string {
  if (n === 100) return 'cien';
  if (n < 100) return menorQueCien(n);
  const centena = Math.floor(n / 100);
  const resto = n % 100;
  const prefijo = CENTENAS[centena]!;
  return resto === 0 ? prefijo : `${prefijo} ${menorQueCien(resto)}`;
}

/** "30" -> "treinta". Fuera de [0, 999999] devuelve el número tal cual (mejor un número plano que un texto incorrecto). */
export function numeroALetras(n: number): string {
  if (!Number.isInteger(n) || n < 0 || n > 999999) return String(n);
  if (n === 0) return 'cero';
  if (n < 1000) return menorQueMil(n);

  const miles = Math.floor(n / 1000);
  const resto = n % 1000;
  const prefijoMiles = miles === 1 ? 'mil' : `${menorQueMil(miles)} mil`;
  return resto === 0 ? prefijoMiles : `${prefijoMiles} ${menorQueMil(resto)}`;
}
